import type { Config } from "../../../../aysa_api/models/config.types";
import type {
  CustomerSession,
  OptionalCustomerSession,
} from "../../../../aysa_api/models/session.types";

export enum Gender {
  UNSPECIFIED = 0,
  FEMALE = 1,
  MALE = 2,
}

export interface SubscribeToWishlistNewsletterRequest {
  config: Config;
  session: CustomerSession;
  email: string;
  gender: Gender;
}

export interface SubscribeToWishlistNewsletterResponse {
  // If the user is subscribed to the 'main' newsletter
  isSubscribedToDefaultNewsletter: boolean;
}

export interface SubscribeToWhatsappNewsletterRequest {
  config: Config;
  session: CustomerSession;
  whatsappToken: string;
  // The country code sent by CRM
  // E.g. https://en.aboutyou.hu/auth?e_waChannelUser=value&countryCode=hu
  externalCountryCode: string;
}

export interface SubscribeToWhatsappNewsletterResponse {}

export interface SubscribeToNewsletterRequest {
  config: Config;
  session: OptionalCustomerSession;
  gender: Gender;
  email: string;
}

export interface SubscribeToNewsletterResponse {}

export interface UnsubscribeFromNewsletterWithTokenRequest {
  config: Config;
  // Token and permission are obtained via the url parmeters from the unsibscribe link within the newsletter itself.
  token: string;
  permission: string;
}

export interface UnsubscribeFromNewsletterWithTokenResponse {}
